import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { Inspector } from './inspector';
import { HttpClient } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { baseUrl, myDayGateway } from './endpoint';
import { GlobalEventsManager } from './global-events-manager';

@Injectable({
  providedIn: 'root'
})
export class MyDayService {

  private url = baseUrl + myDayGateway;

  constructor(
    private http: HttpClient,
    private globalEventsManager: GlobalEventsManager
  ) { }

  getSitesInfo(): Observable<Inspector[]> {
    const url = `${this.url}`;
    return this.http.post<Inspector[]>(url, { token: localStorage.getItem('token'), function: 'getSitesInfo', item1: localStorage.getItem('userId') })
    .pipe(
      catchError(this.handleError('getSitesInfo', []))
    );
  }

  getShiftsInfo(sites: any): Observable<any[]> {
    const url = `${this.url}`;
    return this.http.post<Inspector[]>(url, { token: localStorage.getItem('token'), function: 'getShiftsInfo', item1: sites })
    .pipe(
      catchError(this.handleError('getShiftsInfo', []))
    );
  }

  getFutureShifts(date1: any, date2: any): Observable<any[]> {
    const url = `${this.url}`;
    return this.http.post<any[]>(url, { token: localStorage.getItem('token'), function: 'getFutureShifts', item1: date1, item2: date2 })
    .pipe(
      catchError(this.handleError('getFutureShifts', []))
    );
  }

  private handleError<T> (operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      if (error.error.text === 'expire') {
        this.globalEventsManager.logout(true);
      } else {
        if (error.error.text !== 'Could not Authenticate User') {
          console.error(error);
        }
      }
      return of(result as T);
    };
  }
}
